import Lockr from 'lockr';
import { useCallback } from 'react';
import { DASHBOARD_ACTIVE_CELL_ID } from '../constants';

export function useSetDashboardActiveCellId() {
  const setDashboardActiveCellId = useCallback((cellId: string) => {
    Lockr.set(DASHBOARD_ACTIVE_CELL_ID, cellId);

    /**
     * Widget follow-up actions (widget autofocus, scroll) should be performed within 10 seconds of adding a new widget.
     * Clear it to maintain a clean state.
     */
    setTimeout(() => {
      if (Lockr.get(DASHBOARD_ACTIVE_CELL_ID) === cellId) {
        Lockr.rm(DASHBOARD_ACTIVE_CELL_ID);
      }
    }, 10 * 1000);
  }, []);

  return setDashboardActiveCellId;
}
